import type { TemplateProps } from '../types';
import { ChatIcon } from '../../components/ChatIcon';

export function Trigger({ onOpen }: TemplateProps): preact.JSX.Element {
  return (
    <button
      class="yd-sidebar-tab"
      onClick={(e: Event) => { e.stopPropagation(); onOpen(); }}
      aria-label="Open chat"
    >
      <ChatIcon size={18} />
      <span class="yd-sidebar-tab-text">Chat with us</span>
    </button>
  );
}
